import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { editAccountObject } from '../models/transaction.model';
import {
    DownloadPukalAccount, JAN_Pukal, State_Pukal, SearchSarawakPukal, InitJANPukalObject, InitStatePukalObject, PukalObject
    , AccountOffice, AccountStatus, RecordStatus, AgentCode
} from '../models/pukal-reports.model';

@Injectable()
export class ManagePukalService {
    private warrantServiceURL: string = environment.WMS_Service_URL;

    constructor(protected httpClient: HttpClient) { }

    getAccountOffices(warrantAuthCode: string): Observable<AccountOffice[]> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetAccountOffices";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<AccountOffice[]>(url, {
            headers: header,
            params: new HttpParams()
                .set('warrantAuthCode', warrantAuthCode)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getAccountStatus(): Observable<AccountStatus[]> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetAccountStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<AccountStatus[]>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getRecordStatus(): Observable<RecordStatus[]> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetRecordStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<RecordStatus[]>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getPtjSearchFieldByWarrantAuthCode(warrantAuthCode: string): Observable<AgentCode[]> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetPtjSearchFieldByWarrantAuthCode";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<AgentCode[]>(url, {
            headers: header,
            params: new HttpParams()
                .set('warrantAuthCode', warrantAuthCode)

        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitJANPukal(model: JAN_Pukal): Observable<InitJANPukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetInitJANPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<InitJANPukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    initJANPukal(model: JAN_Pukal): Observable<InitJANPukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/InitJanPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<InitJANPukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFilteredStatePukal(model: JAN_Pukal): Observable<PukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetFilteredStatePukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<PukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFilteredJanPukal(model: JAN_Pukal): Observable<PukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetFilteredJanPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<PukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFilteredOtherPukal(model: State_Pukal): Observable<PukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetFilteredOtherPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<PukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getFilteredSarawakPukal(model: SearchSarawakPukal): Observable<PukalObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/GetFilteredSwkPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<PukalObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadJANIDEA(agentCode: string): Observable<HttpResponse<Blob>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/JANExportPukalToIDEA";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            responseType: 'blob',
            observe: 'response',
            params: new HttpParams()
                .set('airlineAgencyCode', agentCode)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadListFiles(model: any): Observable<HttpEvent<Blob>> {
        let downloadUrl = this.warrantServiceURL + "api/PukalReportsManager/" + model.url;
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(downloadUrl, model, {
            headers: header,
            reportProgress: true,
            responseType: 'blob',
            observe: 'events'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    initEditPukalAccountDetails(airlineAgencyCode: string, accOffCode: string, accNo: string): Observable<editAccountObject> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/InitEditPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<editAccountObject>(url, {
            headers: header,
            params: new HttpParams()
                .set('airlineAgencyCode', airlineAgencyCode)
                .set('accOffCode', accOffCode)
                .set('accNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updatePukalAccountDetails(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/JANUpdatePukalAccountDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<HttpResponse<string>>(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getAddPukalAccountLoad(Warrant_Auth_Code: string): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/AddPukalAccountLoad";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<any>(url, {
            headers: header,
            params: new HttpParams()
                .set('warrantAuthCode', Warrant_Auth_Code)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    NGRAddNewPukalAccount(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/NGRAddNewPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<any>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    initEditNGRPukalAccountDetails(airlineAgencyCode: string, accOffCode: string, accNo: string): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/InitEditNGRPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<any>(url, {
            headers: header,
            params: new HttpParams()
                .set('airlineAgencyCode', airlineAgencyCode)
                .set('accOffCode', accOffCode)
                .set('accNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateNGRPukalAccountDetails(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/NGRUpdatePukalAccountDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<any>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitStateExportView(selectedAccOff: string): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/NGRGetExportPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<any>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadNGRPukalAccountFiles(warrantAuthCode: string, isEncrypted: boolean) {
        let url = this.warrantServiceURL + "api/PukalReportsManager/NGRExport";
        let param: DownloadPukalAccount = new DownloadPukalAccount;
        param.WarrantAuthCode = warrantAuthCode;
        param.Encryption = isEncrypted;

        let body = JSON.stringify(param);
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, body, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    JANAddNewPukalAccount(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/JANAddNewPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post<any>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateJANPukalAccountStatus(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/UpdateFederalPukalAccountStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateNGRPukalAccountStatus(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/UpdateStatePukalAccountStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateSWKPukalAccountStatus(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/UpdateSarawakPukalAccountStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateOtherPukalAccountStatus(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/UpdateOtherPukalAccountStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    exportResetJANPukal(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/ExportResetFederalPukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            // responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    exportResetNGRPukal(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/ExportResetStatePukal";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            // responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getJANExportPukalAccount(): Observable<any> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/JANGetExportPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get<any>(url, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadPtjAccountFiles(isEncrypted: boolean, warrantAuthCode: string) {
        let url = this.warrantServiceURL + "api/PukalReportsManager/DownloadPukalAccountFiles";
        let param: DownloadPukalAccount = new DownloadPukalAccount;
        param.WarrantAuthCode = warrantAuthCode;
        param.Encryption = isEncrypted;

        let body = JSON.stringify(param);
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, body, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getOTHAddPukalAccountLoad(warrantAuthCode: string): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/AddPukalAccountLoad";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('warrantAuthCode', warrantAuthCode)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    OTHAddNewPukalAccount(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/OTHAddNewPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    initEditOTHPukalAccountDetails(airlineAgencyCode: string, accOffCode: string, accNo: string): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/InitEditOTHPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('airlineAgencyCode', airlineAgencyCode)
                .set('accOffCode', accOffCode)
                .set('accNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateOTHPukalAccountDetails(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/OTHUpdatePukalAccountDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    SWKAddNewPukalAccount(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/SWKAddNewPukalAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    initEditSWKPukalAccountDetails(autoNo: string): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/InitEditSWKPukalAccount?autoNo=" + autoNo;
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('autoNo', autoNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateSWKPukalAccountDetails(model: any): Observable<HttpResponse<string>> {
        let url = this.warrantServiceURL + "api/PukalReportsManager/SWKUpdatePukalAccountDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    private handleError(error: Response | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        if (error instanceof Response) {
            return Observable.throw(error);
        } else {
            let errMsg: string;
            errMsg = error.message ? error.message : error.toString();
            console.error(errMsg);
            return Observable.throw(errMsg);
        }
    }
}